import { render } from "./WorkshiftsUnavailabilities.vue?vue&type=template&id=4a77486c"
import script from "./WorkshiftsUnavailabilities.vue?vue&type=script&lang=js"
export * from "./WorkshiftsUnavailabilities.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__